export enum EbookSalesReportEnum {
  SALES = 'SALES',
  PURCHASE_COUNT = 'PURCHASE_COUNT',
  PROMOTION = 'PROMOTION',
  VIEW = 'VIEW',
  READ_TRIAL_CHAPTERS = 'READ_TRIAL_CHAPTERS',
  WISH_EBOOK = 'WISH_EBOOK',
  REVIEW_EBOOK = 'REVIEW_EBOOK',
}
